import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4824bc57"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-opacity"
}, null, -1));

const _hoisted_2 = {
  class: "course-name"
};
const _hoisted_3 = {
  key: 0,
  class: "course-card-info"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "teacher-name"
};
const _hoisted_7 = {
  class: "other"
};
const _hoisted_8 = {
  class: "right"
};
const _hoisted_9 = {
  class: "val"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "累计选课人次", -1));

import { formatDate } from '@/plugins/utils';
import { handleLogin } from '@/plugins/utils';
export default {
  props: {
    info: {
      type: Object
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number,
    // 是否显示详情信息
    showDetail: {
      type: Boolean,
      default: true
    }
  },

  setup(__props) {
    const props = __props;

    const goDetail = () => {
      if (unref(props.authType) == 2 && !unref(props.userInfo)) {
        handleLogin();
      } else {
        window.open(unref(props.info.course_url));
      }
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        onClick: goDetail,
        class: "course-card"
      }, [_createElementVNode("div", {
        class: "course-card-cover",
        style: _normalizeStyle({
          'background-image': `url(${__props.info.course_cover_url || require('@/assets/images/common/course_cover.png')})`
        })
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, _toDisplayString(__props.info.course_name), 1)], 4), __props.showDetail ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        class: "avatar",
        src: __props.info.avatar || require('@/assets/images/user_avatar.jpg')
      }, null, 8, _hoisted_5), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_6, _toDisplayString(__props.info.lecturer), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(__props.info.organ_name), 1)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(__props.info.students_num || 0), 1), _hoisted_10])])) : _createCommentVNode("", true)]);
    };
  }

};